import React from 'react'
import { Button } from 'chemistry'
import { t } from 'client/fragments/productDetailsAddedToBasket/selectors/translations'

export const PopupButtons = ({ isAdded, lang, setIsOpen, finishSurvey }) => {
  return (
    <div className='popup-btn flex flex-column gap-half flex-1'>
      <Button
        isLoading={!isAdded}
        variant='primarySmall'
        fontSize='16px'
        width='min(320px,100%)'
        display='flex'
        textTransform='inherit'
        onClick={() => {
          window.location.href = getLinkToCart(window.location.pathname)
          finishSurvey()
        }}
      >
        {t('toCart', lang)}
      </Button>
      <Button
        onClick={() => {
          setIsOpen(false)
          finishSurvey()
        }}
        variant='secondarySmall'
        width='min(320px,100%)'
        display='flex'
        textTransform='inherit'
      >
        {t('continue', lang)}
      </Button>
    </div>
  )
}

export function getLinkToCart(path) {
  if (path.startsWith('/fr')) return '/fr/makers/cart'
  else if (path.startsWith('/nl')) return '/nl/makers/cart'
  return '/voordemakers/cart'
}
